import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { albums } from "../../assets/data/albums";
import { FaPlus } from "react-icons/fa"; // Import Plus Icon

const PhotoGallery = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const album = albums.find((album) => album.id === parseInt(id));

  const [photos, setPhotos] = useState(album ? album.photos : []);

  if (!album) {
    return <h2>Album not found!</h2>;
  }

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPhotos((prevPhotos) => [...prevPhotos, e.target.result]);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div style={{ padding: "20px", position: "relative" }}>
      {/* Back to Gallery Button in Top-Left Corner */}
      <button
        onClick={() => navigate("/login/assembly-gallery")}
        style={{
          position: "absolute",
          top: "20px",
          left: "20px", // Change to "right: 20px" if you want it in the top-right
          padding: "10px 20px",
          backgroundColor: "#1890ff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Back to Gallery
      </button>

      {/* Album Title */}
      <h1
        style={{
          textAlign: "center",
          marginBottom: "20px",
          color: "brown",
          fontSize: "3rem",
        }}
      >
        {album.name}
      </h1>

      {/* Grid Layout for Photos */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: "20px",
        }}
      >
        {photos.map((photo, index) => (
          <Link to={`/login/albums/${id}/photos/${index}`} key={index}>
            <img
              src={photo}
              alt={`Photo ${index + 1}`}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                border: "1px solid #ccc",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
              onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
            />
          </Link>
        ))}
      </div>

      {/* Hidden File Input */}
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="fileUpload"
      />

      {/* Floating Plus Button */}
      <label
        htmlFor="fileUpload"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "50px",
          height: "50px",
          backgroundColor: "#1890ff",
          color: "white",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.5rem",
          cursor: "pointer",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
        }}
      >
        <FaPlus />
      </label>
    </div>
  );
};

export default PhotoGallery;
